// pwa-update.ts — PWA:n päivitystarkistukset (2.7.2026)
// Ongelma: iPhonen PWA joka pidetään auki taustalla PÄIVIÄ ei koskaan tarkista
// service workerin päivityksiä (selain tarkistaa vain sivulatauksessa / ~24h välein)
// → vanha bundle pyörii vaikka tuotantoon on deployattu monta versiota (havaittu
// 2.7.2026: 29.6. korjattu kuva-input näkyi puhelimessa yhä vanhana).
// Ratkaisu: tarkista päivitys aina kun sovellus palaa etualalle + varmuudeksi
// tunnin välein. autoUpdate + skipWaiting + clientsClaim (vite.config) hoitavat
// aktivoinnin ja sivun päivityksen kun uusi versio löytyy.
import { registerSW } from 'virtual:pwa-register';

const HOUR_MS = 60 * 60 * 1000;

registerSW({
  immediate: true,
  onRegisteredSW(_swUrl, registration) {
    if (!registration) return;
    const check = () => registration.update().catch(() => { /* offline tms. — yritetään taas myöhemmin */ });
    // PWA palaa etualalle (iOS: app switcheristä takaisin) → tarkista heti
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') check();
    });
    // Pitkään auki oleva istunto → tunnin välein
    setInterval(check, HOUR_MS);
  },
});
